import BaseController from "./BaseController";
import DataService from "../util/DataService";
import { Button$PressEvent } from "sap/m/Button";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class Team extends BaseController {

    private readonly DIALOG_ID = "DialogUpdateTeamSettings";

    public async onInit(): Promise<void> {
        const oRouter = this.getOwnerComponent().getRouter();
        oRouter.getRoute("team").attachPatternMatched(this.onObjectMatched, this);
    }

    async onObjectMatched(oEvent: any): Promise<void> {
        const args = oEvent.getParameter("arguments") as { id: string };
        DataService.getTeamData(args.id);
    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    async onUpdateTeamSettings(oEvent: Button$PressEvent): Promise<void> {
        await this.openDialog(this.DIALOG_ID);
    }

    async onSaveDialog(oEvent: Button$PressEvent): Promise<void> {
        DataService.updateTeam();
        this.destroyDialog(this.DIALOG_ID);
    }

    onCloseDialog(): void {
        this.destroyDialog(this.DIALOG_ID);
    }

    onNavigateUser(oEvent: Button$PressEvent): void {
        const currentUser = oEvent.getSource().getBindingContext().getObject() as any;
        this.navTo("user", {
            id: currentUser.id
        });
    }

}
